/* ONI WA SOTO buy box: pack cards, a colour pick per mask, gallery, sticky bar, multi-item add to cart. */
if (!customElements.get('oni-buy-box')) {
  class OniBuyBox extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-oni-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.available = this.variants.filter((v) => v.available);
      this.packs = Array.from(this.querySelectorAll('[data-pack]'));
      this.slotsEl = this.querySelector('[data-oni-slots]');
      this.legend = this.querySelector('[data-oni-colour-legend]');
      this.summary = this.querySelector('[data-oni-summary]');
      this.form = this.querySelector('[data-oni-form]');
      this.addBtn = this.querySelector('[data-oni-add]');
      this.errorEl = this.querySelector('[data-oni-error]');
      this.sticky = this.querySelector('[data-oni-sticky]');

      const pressed = this.packs.find((b) => b.getAttribute('aria-pressed') === 'true') || this.packs[0];
      this.qty = pressed ? parseInt(pressed.dataset.pack, 10) || 1 : 1;

      const firstPressed = this.querySelector('.oni-swatch[aria-pressed="true"]');
      const firstId = firstPressed ? parseInt(firstPressed.dataset.variant, 10) : this.available[0] && this.available[0].id;
      const pool = this.available.length ? this.available : this.variants;
      const startIndex = Math.max(0, pool.findIndex((v) => v.id === firstId));
      this.picks = Array.from({ length: 12 }, (_, i) => (pool[(startIndex + i) % pool.length] || {}).id);

      this.packs.forEach((btn) => btn.addEventListener('click', () => this.setPack(parseInt(btn.dataset.pack, 10) || 1)));
      this.querySelectorAll('[data-thumb]').forEach((t) => t.addEventListener('click', () => this.showMedia(t.dataset.thumb)));
      if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add(); });
      const stickyAdd = this.querySelector('[data-oni-sticky-add]');
      if (stickyAdd) stickyAdd.addEventListener('click', () => this.add());
      this.watchSticky();
      this.render();
    }

    setPack(qty) {
      this.qty = qty;
      this.render();
    }

    variantById(id) {
      return this.variants.find((v) => v.id === id);
    }

    render() {
      this.packs.forEach((b) => b.setAttribute('aria-pressed', String(parseInt(b.dataset.pack, 10) === this.qty)));
      if (this.legend) this.legend.textContent = this.qty > 1 ? this.legend.dataset.multi : this.legend.dataset.single;
      this.renderSlots();
      this.renderSummary();
      const pressed = this.packs.find((b) => b.getAttribute('aria-pressed') === 'true');
      const priceText = pressed ? (pressed.querySelector('[data-pack-price]') || {}).textContent : '';
      const stickyPrice = this.querySelector('[data-oni-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = priceText || '';
      if (this.addBtn && !this.addBtn.disabled && priceText) {
        this.addBtn.dataset.label = this.addBtn.dataset.label || this.addBtn.textContent.trim();
        this.addBtn.textContent = `${this.addBtn.dataset.label} — ${priceText.trim()}`;
      }
    }

    renderSlots() {
      if (!this.slotsEl || this.variants.length < 2) return;
      this.slotsEl.replaceChildren();
      for (let i = 0; i < this.qty; i++) {
        const row = document.createElement('div');
        row.className = 'oni-slot';
        if (this.qty > 1) {
          const label = document.createElement('span');
          label.className = 'oni-mono oni-slot__label';
          label.textContent = `Mask ${i + 1}`;
          row.appendChild(label);
        }
        this.variants.forEach((v) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'oni-swatch';
          btn.setAttribute('aria-pressed', String(this.picks[i] === v.id));
          btn.setAttribute('aria-label', `${this.qty > 1 ? `Mask ${i + 1}: ` : ''}${v.title}${v.available ? '' : ' — sold out'}`);
          btn.disabled = !v.available;
          const dot = document.createElement('span');
          dot.className = 'oni-swatch__dot';
          dot.style.background = v.hex;
          const name = document.createElement('span');
          name.className = 'oni-swatch__name';
          name.textContent = v.short;
          btn.append(dot, name);
          btn.addEventListener('click', () => {
            this.picks[i] = v.id;
            if (i === 0 && v.media) this.showMedia(v.media);
            this.render();
            const again = this.slotsEl.children[i] && this.slotsEl.children[i].querySelectorAll('.oni-swatch')[this.variants.indexOf(v)];
            if (again) again.focus();
          });
          row.appendChild(btn);
        });
        this.slotsEl.appendChild(row);
      }
    }

    renderSummary() {
      if (!this.summary) return;
      const counts = new Map();
      this.picks.slice(0, this.qty).forEach((id) => counts.set(id, (counts.get(id) || 0) + 1));
      const parts = [];
      counts.forEach((n, id) => {
        const v = this.variantById(id);
        if (v) parts.push(`${n}× ${v.title}`);
      });
      this.summary.replaceChildren();
      const prefix = document.createTextNode(`${this.dataset.summaryPrefix || ''} `);
      const strong = document.createElement('strong');
      strong.textContent = parts.join(', ');
      this.summary.append(prefix, strong);
    }

    showMedia(id) {
      if (!id) return;
      const target = this.querySelector(`[data-media-id="${id}"]`);
      if (!target) return;
      this.querySelectorAll('[data-media-id]').forEach((el) => {
        const on = el === target;
        el.hidden = !on;
        const vid = el.querySelector('video');
        if (vid) { if (on) { vid.play().catch(() => {}); } else { vid.pause(); } }
      });
      this.querySelectorAll('[data-thumb]').forEach((t) => t.setAttribute('aria-current', String(t.dataset.thumb === String(id))));
    }

    async add() {
      if (this.busy) return;
      const counts = new Map();
      this.picks.slice(0, this.qty).forEach((id) => { if (id) counts.set(id, (counts.get(id) || 0) + 1); });
      const items = Array.from(counts, ([id, quantity]) => ({ id, quantity }));
      if (!items.length) return;
      this.busy = true;
      if (this.addBtn) this.addBtn.disabled = true;
      if (this.errorEl) this.errorEl.hidden = true;
      try {
        const res = await fetch(`${this.dataset.cartAddUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Could not add to cart. Please try again.');
        }
        window.location.href = this.dataset.cartUrl;
      } catch (e) {
        if (this.errorEl) { this.errorEl.textContent = e.message; this.errorEl.hidden = false; }
        if (this.addBtn) this.addBtn.disabled = false;
        this.busy = false;
      }
    }

    watchSticky() {
      if (!this.sticky || !this.addBtn || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(([entry]) => {
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.sticky.classList.toggle('is-visible', past);
        this.sticky.setAttribute('aria-hidden', String(!past));
        const btn = this.sticky.querySelector('button');
        if (btn) btn.tabIndex = past ? 0 : -1;
      });
      io.observe(this.addBtn);
    }
  }
  customElements.define('oni-buy-box', OniBuyBox);
}
